// hooks/useSelectUser.js
import { useQuery } from "@tanstack/react-query";
import usersAPI from "features/Setting/users/api/userApis";
import apiClient from "lib/api-client";
import { getUserDetail } from "utils/getUserDetailsHelper";

export const useSelectUser = () =>
  useQuery({
    queryKey: ['WabaRights'],
    queryFn: usersAPI.getAllUserData,
    cacheTime: 200000,
    staleTime: 20000,
    refetchOnWindowFocus: true,
  });

// ------------------------------  Update Rate Master ----------------------------- //

  export const updateLocationWithWhatsUpNumber = async (payload) => {
    let response = await apiClient.post(`/api/v1/rateMaster/location`, payload);
    return response.data;
  };

// ------------------------------  Get Rate Master ----------------------------- //

  export const getUserWhatsUpsRights = async (User) => {
    let response = await apiClient.get(`/api/v1/rateMaster/location?userId=${User}`);
    return response.data;
  };

